import $ from 'jquery';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel';
import './../stylesheets/index.styl';
import Cookies from 'js-cookie';

const slick = () => {
    ($('.slider__container') as any).slick({
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true
    });

    ($('.referenceSection__list') as any).slick({
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        autoplaySpeed: 10000
    });
};

const clients = () => {
    $('.tabs__header-item').on('click', (e) => {
        const index = $(e.currentTarget).attr('data-index');

        $('.tabs__header-item').removeClass('tabs__header-item--active');
        $(e.currentTarget).addClass('tabs__header-item--active');
        $('.tabs__body-item').removeClass('tabs__body-item--active');
        $(`.tabs__body-item:nth-of-type(${index})`).addClass('tabs__body-item--active');
    });
};

const changeLanguages = () => {
    $('.mainHeader__languages').on('change', (e: any) => {
        const language = e.target.value.toLowerCase();

        window.location.href = `${(window as any).SITE_URL}?lang=${language}`;
    });
};

const contactForm = () => {
    $('.contactForm__form').on('submit', (e) => {
        e.preventDefault();
        const values = $(e.target).serialize();
        $('input, textarea, button', e.target).attr('disabled', 1);

        $.post(`/api/contact`, values, (response) => {
            if(response === 'email_send') {
                $('.contactForm__form').addClass('contactForm__form--sended');
            }
        });
    });
};

const mobileMenu = () => {
    $('.mainHeader__right-bottom--mobile').on('click', () => {
        if($('.mainHeader__mobileMenu').hasClass('mainHeader__mobileMenu--active')) {
            $('.mainHeader__mobileMenu').removeClass('mainHeader__mobileMenu--active');
        }
        else {
            $('.mainHeader__mobileMenu').addClass('mainHeader__mobileMenu--active');
        }
    });
};

const showCookiesModal = () => {
    const modal = $('.cookies');

    if(!Cookies.get('COOKIES_ACCEPTED')) {
        modal.addClass('cookies--active');
    }

    $('.cookies__body-button').on('click', () => {
        $('.cookies').remove();
        Cookies.set('COOKIES_ACCEPTED', true);
    });
};

const liveChat = () => {
    $('[name=liveChat]').on('submit', (e) => {
        e.preventDefault();
        (window as any).LC_API.open_chat_window();
    });
};

(window as any).mapLoaded = () => {
    const node = $('.map__init');
    if(!node.length) return;

    const position = {
        lat: +(node as any).attr('data-lat'),
        lng: +(node as any).attr('data-lng')
    };

    const map = new (window as any).google.maps.Map((node as any)[0], {
        center: position,
        zoom: 14
    });

    // tslint:disable-next-line
    new (window as any).google.maps.Marker({
        position,
        map
    });
};

const showMoreText = () => {
    $('.members__item-description__button').on('click', (e) => {
        e.preventDefault();
        $(e.target)
            .closest('.members__item-container')
            .addClass('members__item-container--active');
    });
};

$(() => {
    changeLanguages();
    clients();
    slick();
    contactForm();
    mobileMenu();
    liveChat();
    showMoreText();
    showCookiesModal();
});
